<template>
  <div class="con-wrap" style="background-color:#fff;margin-top:0">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div class="query-box">
        <el-form-item class="r-20" prop="userAccount">
          <div class="selectBox">
            <el-input
              class="selectInput"
              v-model="udeptName"
              @click.native="clickInput"
              placeholder="请选择部门"
              readonly
            ></el-input>
            <div class="deptTree" :class="{ active: show == true }">
              <div class="custom-tree-container">
                <div class="block">
                  <el-tree
                    :data="udeptTreeData"
                    node-key="id"
                    @node-click="getUserList"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                  >
                    <span
                      class="custom-tree-node is-show"
                      slot-scope="{ node }"
                    >
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item class="date-input r-20">
          <date-picker
            :startTime="queryForm.startTime"
            :endTime="queryForm.endTime"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="hasPerm('statistics:data:dynamo')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('statistics:data:dynamo')" @click="reset"
            >取消</el-button
          >
        </el-form-item>
      </div>

      <div style="margin-bottom:20px">
        <el-button
          v-if="hasPerm('statistics:data:dynamo:export')"
          type="primary"
          @click="exportData"
          >数据导出</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
    >
      <el-table-column
        type="index"
        align="center"
        label="序号"
        width="55"
      ></el-table-column>
      <el-table-column prop="name" label="车辆绑定人"></el-table-column>
      <el-table-column
        prop="account"
        label="车主账号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="发电开始时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="发电结束时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="capacity"
        label="发电量（kW·h）"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="duration"
        label="发电时长"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oil"
        label="发电油耗（L）"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="stationName"
        label="站址名称"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue"
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      queryForm: {
        deptId: "",
        userAccount: "",
        startTime: "",
        endTime: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      udeptName: "",
      udeptId: "",
      udeptTreeData: [],
      show: false,
    }
  },
  created() {
    this.getRecordList()
    this.getDeptTree()
  },
  methods: {
    clickInput() {
      this.show = !this.show
    },
    changeStart(val) {
      console.log(val + "---")
      this.queryForm.startTime = val
    },
    changeEnd(val) {
      this.queryForm.endTime = val
    },
    exportStart(val) {
      this.exportStartTime = val
    },
    exportEnd(val) {
      this.exportEndTime = val
    },
    async getDeptTree() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dept/list")
      if (res.code == 1) {
        _this.udeptTreeData = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getRecordList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        deptId: this.queryForm.deptId,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
      }
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/v2/statistics/data/dynamo",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    exportData() {
      let _this = this
      let url = ""
      _this
        .$confirm("确定导出当前查询条件下的数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          url =
            "/api/v2/statistics/data/dynamo/export?startTime=" +
            _this.queryForm.startTime +
            "&endTime=" +
            _this.queryForm.endTime +
            "&deptId=" +
            _this.queryForm.deptId

          window.location.href = url
        })
    },
    async getUserList(data) {
      console.log(data)
      let _this = this
      _this.udeptName = data.label
      _this.queryForm.deptId = data.id
      _this.show = !_this.show
    },
    query() {
      this.currentPage = 1
      this.getRecordList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.queryForm.startTime = ""
      this.queryForm.endTime = ""
      this.udeptName = ""
      this.queryForm.deptId = ""
      this.currentPage = 1
      this.getRecordList()
    },
    //选择数据变化监控
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getRecordList()
    },
  },
}
</script>

<style lang="scss" scoped>
.query-box /deep/ .el-date-editor {
  width: 100% !important;
}
.date-input /deep/ {
  .el-form-item__content {
    width: 620px;
    .el-col-1 {
      margin-left: 18px !important;
    }
  }
}
.con-wrap /deep/ .mini-dialog .el-form-item__label {
  width: 110px;
  margin-left: 0;
}
.selectBox .selectInput /deep/ .el-input__inner {
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.deptTree {
  width: 100%;
  height: 540px;
  overflow: auto;
  margin-left: 18px;
  position: absolute;
  top: 40px;
  left: -18px;
  font-size: 14px;
  display: none;
  z-index: 2;
}
.deptTree.active {
  display: block;
}
</style>
